import React from 'react'
import {Elements} from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

// Make sure to call `loadStripe` outside a component’s render to avoid
// recreating the `Stripe` object on every render.
const PUBLIC_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || ''

let stripePromise: Promise<any> | null = null

const loadStripeWithFallback = () => {
  if (!PUBLIC_KEY) {
    console.warn('⚠️ Stripe public key is missing. Please set VITE_STRIPE_PUBLISHABLE_KEY in your .env file.')
    return Promise.resolve(null)
  }

  if (!stripePromise) {
    stripePromise = loadStripe(PUBLIC_KEY).catch(error => {
      console.error('❌ Failed to load Stripe.js:', error)
      return null
    })
  }

  return stripePromise
}

const stripePromiseSafe = loadStripeWithFallback()

export function  StripeProvider({ children } : {children: React.ReactNode}) {
  if (!stripePromiseSafe) {
    return <>{children}</>
  }

  return (
    <Elements stripe={stripePromiseSafe}>
      {children}
    </Elements>
  );
}
